// services/agentService.js
import { apiClient } from "./apiClient";


// Send a chat message to the agent backend
export async function sendAgentMessageApi({ workspaceId, token, message}) {

    const data = {
        message:message
    }

    return apiClient(`/agent/message/${workspaceId}`, {
        token,
        method: "POST",
        body: data,
    });
}